import { matchPath } from 'react-router';
import { some, filter } from 'lodash';

export const match = (current, ...routes) => {
    return some(routes, r =>
        matchPath(current, {
            path: r,
            exact: true,
            strict: false
        })
    );
};

export const routeWithContext = (contextSubject, route, contextRoute) =>
    !!contextSubject ? contextRoute.replace(':context', contextSubject) : route;

export const removeLastPart = (route, amount = 1) => {
    return filter(route.split('/'), (r, i) => !!r || i === 0)
        .slice(0, -amount)
        .join('/');
};

export const addContextToRoute = (route, context) => {
    const prefix = '/admin';
    const split = route.split(prefix);
    split[0] = `${prefix}/organizations/${context}`;
    return split.join('');
};

export const buildUrl = (route, urlParams) => {
    if (urlParams) {
        const { page, resultsPerPage } = urlParams;
        return `${route}${route.includes('?') ? '&' : '?'}pagesize=${resultsPerPage}&page=${page}${
            urlParams.sort ? `&order=${urlParams.sort}` : ''
        }${urlParams.query ? `&query=${urlParams.query}` : ''}${urlParams.type ? `&type=${urlParams.type}` : ''}`;
    } else {
        return route;
    }
};
